'use client';

import { useTranslations } from 'next-intl';

export function HeroSection() {
  const t = useTranslations('pricing');

  return (
    <section
      className="flex h-[316px] w-full items-center justify-center bg-center bg-cover bg-no-repeat sm:h-[250px]"
      style={{ backgroundImage: 'url(https://image01-aliyun.vidu.zone/vidu/media-asset/093834-5CbaKFvVtOIG7Fv7.webp)' }}
    >
      <div className="container mx-auto px-4 pt-20 text-center sm:pt-10">
        <h1 className="text-center font-medium text-[48px] text-white leading-[100%] tracking-[0%] sm:text-[28px]">
          {t('slogan')}
        </h1>
      </div>
    </section>
  );
}
